import React from 'react';

import {
  DesktopWrapper,
  DesktopContainer,
  DesktopNav,
  DesktopUtilityNav,
  DesktopInBetweenMq,
  MobileWrapper,
  MobileContainer,
  MobileUtilityNav,
  SkeletonNavItem,
  SkeletonMenuButton,
  SkeletonSearchButton,
  SkeletonSearchContainer,
  SkeletonUserButton,
  SkeletonCartButton,
  SkeletonStoreStatus,
  SkeletonMenuType,
  Divider,
} from './placeholder-navigation.styles';

type PlaceholderNavigationProps = {
  isAccountEnabled?: boolean;
};

/**
 * Renders a placeholder navigation skeleton to display before dispensary data is loaded.
 * This component mirrors the structure of the real navigation to minimize layout shift (CLS)
 * and maintain good Largest Contentful Paint (LCP) metrics.
 */
export const PlaceholderNavigation = ({ isAccountEnabled = true }: PlaceholderNavigationProps): JSX.Element => (
  <>
    {/* Desktop placeholder - visible on screens >= 880px */}
    <DesktopWrapper data-testid='placeholder-navigation-desktop'>
      <DesktopContainer>
        <DesktopNav>
          <SkeletonNavItem aria-hidden='true' />
          <SkeletonNavItem aria-hidden='true' />
          <SkeletonSearchContainer>
            <SkeletonSearchButton aria-hidden='true' />
          </SkeletonSearchContainer>
        </DesktopNav>

        <DesktopUtilityNav>
          <DesktopInBetweenMq>
            <SkeletonStoreStatus aria-hidden='true' />
            <Divider />
            <SkeletonMenuType aria-hidden='true' />
            {isAccountEnabled && <Divider />}
          </DesktopInBetweenMq>

          {isAccountEnabled && <SkeletonUserButton aria-hidden='true' />}
          <SkeletonCartButton aria-hidden='true' />
        </DesktopUtilityNav>
      </DesktopContainer>
    </DesktopWrapper>

    {/* Mobile placeholder - visible on screens < 880px */}
    <MobileWrapper data-testid='placeholder-navigation-mobile'>
      <MobileContainer>
        <SkeletonMenuButton aria-hidden='true' />

        <SkeletonSearchContainer>
          <SkeletonSearchButton aria-hidden='true' />
        </SkeletonSearchContainer>

        <MobileUtilityNav>
          {isAccountEnabled && <SkeletonUserButton aria-hidden='true' />}
          <SkeletonCartButton aria-hidden='true' />
        </MobileUtilityNav>
      </MobileContainer>
    </MobileWrapper>
  </>
);
